<template>
    <!-- eslint-disable -->
    <div class="assessment-view-page">
        <div class="page-header">
            <h4>
                {{ pageTitle }}
                <span class="autosave">{{ autoSaveMessage }}</span>
            </h4>
            <ol class="breadcrumbs">
                <li class="breadcrumb-item home">
                    <router-link to="/dashboard">Home</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="'/assessments'">View Assessments</router-link>
                </li>
                <li class="breadcrumb-item active">
                    <span class="inline-block">Assessment Details</span>
                </li>
            </ol>
        </div>
        <div class="assessment-view-body">
            <tabs :options="{ useUrlFragment: false, isOrdered:true }" @changed="changedTab" ref="assessment-view-tabs">
                <tab v-if="isInsuredAssessmentType"
                     name="Insured"
                     id="assessment-view-insured"
                     :isShow="isInsuredAssessmentType"
                     :order="100"
                     :class-name="'tab-content-table'">
                    <assessment-view-insured-tab
                            :insured="insured"
                            :vehicleOwnerNames = "vehicleOwnerNames"
                            :estimators="estimators"
                            :assessment="assessment"
                            :assessmentTab="assessmentTab"
                            :all-items="allItems"
                            :onSelectAssessor="onSelectAssessor"
                            :assessorsList="assessorsList"
                            :legalFirms="legalFirms"
                            @new-legal-firm="newLegalFirm"
                            :isEditableAccidentDetails="isEditableAccidentDetails"
                            :isEditable="isEditable"
                    >
                    </assessment-view-insured-tab>
                </tab>
                <tab v-if="isOtherPartyAssessmentType"
                     name="Other Party"
                     id="assessment-view-other-party"
                     :isShow="isOtherPartyAssessmentType"
                     :order="200"
                     :class-name="'tab-content-table'">
                    <assessment-view-other-party-tab
                            :otherParty="otherParty"
                            :assessment="assessment"
                            :vehicleOwnerNames = "vehicleOwnerNames"
                            :assessmentTab="assessmentTab"
                            :all-items="allItems"
                            :onSelectAssessor="onSelectAssessor"
                            :assessorsList="assessorsList"
                            :legalFirms="legalFirms"
                            @new-legal-firm="newLegalFirm"
                            :isEditableAccidentDetails="isEditableAccidentDetails"
                            :isEditable="isEditable"
                    >
                    </assessment-view-other-party-tab>
                </tab>

                <tab name="Assessment"
                     id="assessment-view-assessment"
                     :order="300"
                     :class-name="'tab-content-table'">
                    <assessment-tab
                            :all-items="allItems"
                            :info="info"
                            :assessmentTab="assessmentTab"
                            :assessmentId="assessmentId"
                            :policyNumber="policyNumber"
                            :viewer-is-assessor="viewerIsAssessor"
                            :additionalPrices="additionalPrices">

                    </assessment-tab>
                </tab>
                <template v-if="allItems.length == 1">
                    <items-list-tab
                            :assessment="assessment"
                            :estimate="allItems[0]"
                            :isOnlyOneEstimate="true"
                            :autoSaveItemPart="autoSaveItemPart"
                            :moveItemPart="moveItemPart"
                    >
                    </items-list-tab>
                </template>
                <template v-if="allItems.length > 1" v-for="estimate in allItems">
                    <items-list-tab
                            :assessment="assessment"
                            :estimate="estimate"
                            :isOnlyOneEstimate="false"
                            :autoSaveItemPart="autoSaveItemPart"
                            :moveItemPart="moveItemPart"
                    >
                    </items-list-tab>
                </template>
                <tab name="Images"
                     :order="500"
                     :counter="imageList.length"
                     id="assessment-view-images"
                     :class-name="'tab-content-table'">

                    <images-tab :imageList="imageList" @imageUploaded="loadImages" @changeImageCategory="changeImageCategory">

                    </images-tab>
                </tab>
                <tab name="Files"
                     :order="600"
                     :counter="filesList.length"
                     id="assessment-view-files"
                     :class-name="'tab-content-table'">
                    <files-tab
                            :files-list="filesList"
                            :assessment-id="assessmentId"
                            @fileUploaded="loadFiles"
                            @changeFile="changeFile"
                    />
                </tab>
                <tab name="Notes"
                     :order="700"
                     :counter="notes.length"
                     id="assessment-view-notes"
                     :class-name="'tab-content-table'">

                    <notes
                            :notes="notes"
                            :search="notesSearch"
                            :add-note-trigger="addNoteTrigger"
                            :assessment-id="assessment.id"
                            @loadNotes="loadNotes"
                    ></notes>

                </tab>
                <tab name="Activity"
                     ref="activity-tab"
                     :order="800"
                     id="assessment-view-activity"
                     :class-name="'tab-content-table'">
                    <ActivityTab
                            ref="assessment-view-activity-tab"
                            :assessment="assessment"
                            @loadImages="loadImages"
                            @loadFiles="loadFiles"
                    />
                </tab>

                <template slot="nav-item-right">
                    <!-- pin image -->
                    <div class="tabs-nav-right-pin-images">
                        <label class="form-check-inline checkbox"
                               v-b-tooltip.hover="{customClass: 'ps-tooltip', title: 'Click to view images', placement:'left'}">
                            <input class="form-check-input" name="pinimage" v-model="pinImage" type="checkbox">
                            <span class="icon"><i class='bx bx-check'></i></span>
                            <span class="text">Pin Images</span>
                        </label>
                    </div>

                    <div v-show="activeTab == 'Notes'" class="tabs-nav-right-search">
                        <b-form-input v-model="notesSearch" type="text" class="search-input" placeholder="Search for Notes"
                                      debounce="100"></b-form-input>
                    </div>

                    <!-- mobile options -->
                    <div class="ml-4">
                        <b-dropdown class="dropdown-options dropdown-options--icon-only" right dropleft no-caret>
                            <template v-slot:button-content>
                                <span class="dropdown-arrow">
                                    <i class='bx bxs-chevron-down'></i>
                                </span>
                            </template>

                            <b-dropdown-item @click="addNote">Add Note</b-dropdown-item>
                            <b-dropdown-item @click="addSupplement">Add Supplement</b-dropdown-item>
                            <b-dropdown-item v-if="assessment.rsEstimateId" @click="updateDataInRepairShop">Update Repair-shop</b-dropdown-item>
                            <b-dropdown id="dropdown-2" dropleft text="Chck Against Schedule" class="options-check-time">
                                <template v-slot:button-content>
                                    Chck Against Schedule
                                </template>
                                <b-dropdown-item @click="checkTimes('ntar')">NTAR Times</b-dropdown-item>
                                <b-dropdown-item @click="checkTimes('ltar')">LTAR Times</b-dropdown-item>
                                <b-dropdown-item @click="checkTimes('rs'  )">RS Times</b-dropdown-item>
                            </b-dropdown>

                            <b-dropdown-item @click="downloadAuthorityPdf">Print Repair Authority</b-dropdown-item>

                            <b-dropdown-item v-show="!isSupItemListTabSelected" :to="'/assessments/'+ assessmentId + '/print-report'">Print Assessment Report</b-dropdown-item>
                            <b-dropdown-item @click="sendRepairerNotice">Send Repairer Notice</b-dropdown-item>
                            <b-dropdown-item v-show="isSupItemListTabSelected" :to="'/assessments/estimate/'+ selectedSupItemListId + '/print-report'">Print Sup-Assessment Report</b-dropdown-item>

                            <b-dropdown-item v-if="isShowMarkAsProcessed" @click="markAssessmentAsProcessing">Mark as Processed</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsOnHold" @click="markAssessmentAsOnHold">Mark On Hold</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsNew" @click="markAssessmentAsNew">Mark as New</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsWRecoveries" @click="markAssessmentAsWRecoveries">Mark as W/Recoveries</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsCompleted" @click="markAssessmentAsCompleted">Mark as Completed</b-dropdown-item>

                            <b-dropdown-item v-if="!viewerIsAssessor" @click="clickOnForDelete">Delete Assessment</b-dropdown-item>
                            <b-dropdown-item v-if="isPossibilityCreateInvoice && !hasInvoice && !isUserRoleAssessor" @click="createInvoice">Create Invoice</b-dropdown-item>
                            <b-dropdown-item v-if="hasInvoice && !isUserRoleAssessor" @click="goToInvoice">Go To Invoice</b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <div class="tabs-nav-right-options ml-4">
                        <b-dropdown id="view-options" ref="optionMenu" text="Options" class="dropdown-options mr-0">
                            <template v-slot:button-content>
                                Options
                                <span class="dropdown-arrow">
                                    <i class='bx bxs-chevron-down'></i>
                                </span>
                            </template>
                            <b-dropdown-item @click="addNote">Add Note</b-dropdown-item>
                            <b-dropdown-item @click="createTask">Add Task</b-dropdown-item>
                            <b-dropdown-item v-if="!isUserRoleLawyer" @click="addSupplement">Add Supplement</b-dropdown-item>
                            <b-dropdown-item v-if="assessment.rsEstimateId && !isUserRoleLawyer" @click="updateDataInRepairShop">Update Repair-shop</b-dropdown-item>
                            <b-dropdown v-if="!isUserRoleLawyer" id="dropdown-2" dropleft text="Chck Against Schedule" class="options-check-time">
                                <template v-slot:button-content>
                                    Chck Against Schedule
                                </template>
                                <b-dropdown-item @click="checkTimes('ntar')">NTAR Times</b-dropdown-item>
                                <b-dropdown-item @click="checkTimes('ltar')">LTAR Times</b-dropdown-item>
                                <b-dropdown-item @click="checkTimes('rs'  )">RS Times</b-dropdown-item>
                            </b-dropdown>

                            <b-dropdown-item v-if="!isUserRoleLawyer" @click="downloadAuthorityPdf">Print Repair Authority</b-dropdown-item>

                            <b-dropdown-item v-if="!isUserRoleLawyer" v-show="!isSupItemListTabSelected" :to="'/assessments/'+ assessmentId + '/print-report'">Print Assessment Report</b-dropdown-item>
                            <b-dropdown-item v-if="!isUserRoleLawyer" v-show="isSupItemListTabSelected" :to="'/assessments/estimate/'+ selectedSupItemListId + '/print-report'">Print Sup-Assessment
                                Report
                            </b-dropdown-item>
                            <b-dropdown-item v-if="!isUserRoleAssessor && !isUserRoleLawyer" @click="sendRepairerNotice">Send Repairer Notice</b-dropdown-item>

                            <b-dropdown-item v-if="isShowMarkAsProcessed && !isUserRoleLawyer" @click="markAssessmentAsProcessing">Mark as Processed</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsOnHold && !isUserRoleLawyer" @click="markAssessmentAsOnHold">Mark On Hold</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsNew && !isUserRoleLawyer" @click="markAssessmentAsNew">Mark as New</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsWRecoveries && !isUserRoleLawyer" @click="markAssessmentAsWRecoveries">Mark as W/Recoveries</b-dropdown-item>
                            <b-dropdown-item v-if="isShowMarkAsCompleted && !isUserRoleLawyer" @click="markAssessmentAsCompleted">Mark as Completed</b-dropdown-item>

                            <b-dropdown-item v-if="!viewerIsAssessor  && !isUserRoleLawyer" @click="clickOnForDelete">Delete Assessment</b-dropdown-item>
                            <b-dropdown-item v-if="isPossibilityCreateInvoice && !hasInvoice && !isUserRoleAssessor && !isUserRoleLawyer" @click="createInvoice">Create Invoice</b-dropdown-item>
                            <b-dropdown-item v-if="hasInvoice && !isUserRoleAssessor" @click="goToInvoice">Go To Invoice</b-dropdown-item>

                        </b-dropdown>
                    </div>
                </template>
            </tabs>
        </div>

        <!-- pin image -->
        <transition name="slide-fade">
            <image-pin-area
                    v-if="pinImage"
                    :image-list="imageList"
                    @click-image="handleSelectPinImage"
                    @close="pinImage = false">
            </image-pin-area>
        </transition>

        <!-- image gallery -->
        <template v-if="showGallery">
            <image-gallery :use-editor="false"
                           :isDownload="true"
                           :isRemove="true"
                           :images="imageList"
                           :current-index="galleryCurrentIndex"
                           @remove-image="deleteImage"
                           @close-gallery="handleCloseGallery">
            </image-gallery>
        </template>
        <b-modal :centered="true" id="deleteAssessmentModal" ref="deleteAssessmentModal" aria-labelledby="deleteAssessmentModalLabel" header-class="modal-header-background" footer-bg-variant="light"
                 style="top: 10vh">
            <template v-slot:modal-header>
                <h4 class="modal-title" id="deleteAssessmentModalLabel">Delete Assessment</h4>
                <button @click="$bvModal.hide('deleteAssessmentModal')" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style="color:#FFFFFF;">&times;</span>
                </button>
            </template>
            <template v-slot:default class="modal-body">
                <div class="form-group">
                    <p>The following assesment and its linked items will be deleted</p>
                    <p></p>
                    <p><span class="font-nunito--bold">Assessment Nbr:</span> {{dataDeleteAssessment.assessment.number}} </p>
                    <p v-if="dataDeleteAssessment.invoice"><span class="font-nunito--bold">Invoice Nbr:</span> {{dataDeleteAssessment.invoice.number}} </p>
                </div>
            </template>
            <template v-slot:modal-footer class="modal-footer">
                <button @click="deleteAssessment" type="button" class="btn btn-primary" style="width:70px;">OK</button>
                <button @click="$bvModal.hide('deleteAssessmentModal')" type="button" class="btn btn-secondary" data-dismiss="modal" style="width:70px;">Cancel</button>
            </template>
        </b-modal>

        <b-modal :centered="true" id="checkTimesModal" ref="checkTimesModal" header-class="modal-header-background" footer-bg-variant="light" size="md">
            <template v-slot:modal-header>
                <h4 class="modal-title" id="checkTimesModalLabel">Check Against Schedule</h4>
                <button @click="$bvModal.hide('checkTimesModal')" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" style="color:#FFFFFF;">&times;</span>
                </button>
            </template>
            <template v-slot:default class="modal-body">
                <div class="form-group">

                    <p v-if="!checkResults" class="text-center">
                        <b-spinner class="theme-color"></b-spinner>
                    </p>

                    <template v-else>
                        <h4 class="mb-3">Times Schedule: {{ matchingItemsType }}</h4>
                        <template v-for="[key, value] of Object.entries(checkResults)">
                            <h5>{{ key }}</h5>
                            <p>{{ value.matched }} item(s) matched</p>
                            <p>{{ value.notMatched }} item(s) not matched</p>
                        </template>
                    </template>

                </div>
            </template>
            <template v-slot:modal-footer class="modal-footer">
                <button @click="approveItems(false)" type="button" class="btn btn-primary" :disabled="!checkResults || !matchingItemsResults">Approve Matched</button>
                <button @click="approveItems(true)" type="button" class="btn btn-primary" :disabled="!checkResults || !matchingItemsResults">Approve All</button>
                <button @click="$bvModal.hide('checkTimesModal')" type="button" class="btn btn-secondary" data-dismiss="modal" style="width:70px;">Cancel</button>
            </template>
        </b-modal>
    </div>
</template>
<script>
    /* eslint-disable */

    import Axios from 'axios';
    import _ from "lodash";
    import AssessmentTab from "./assessment-view/assessment-tab";
    import AssessmentViewOtherPartyTab from "./assessment-view/other-party-tab";
    import ItemsListTab from "./assessment-view/items-list-tab";
    import AssessmentViewInsuredTab from "./assessment-view/insured-tab";
    import imagePinArea from "../../components/image-pin-area";
    import imageGallery from "../../components/image-lightbox/image-gallery";
    import FileUpload from "../../components/FileUpload";
    import NumberFormatter from '@/components/number-formatter';
    import FilesTab from './assessment-view/files-tab';
    import ImagesTab from './assessment-view/images-tab';
    import {mapGetters} from 'vuex';
    import Notes from './assessment-view/notes';
    import ActivityTab from './assessment-view/activity-tab';

    export default {
        name: 'assessment-view',
        data: function () {
            return {
                isDropdown2Visible: false,
                checkResults: null,
                matchingItemsResults: null,
                matchingItemsType: '',
                dataDeleteAssessment: {
                    assessment: {
                        number: '',
                        id: 0,
                    },
                    invoice: {
                        number: '',
                        id: 0,
                    },
                },
                autoSaveUpdate: {},
                autoSaveMessage: '',
                isAutoSave: false,
                assessmentId: 0,
                info: {
                    vehicle: {},
                    details: {
                        number: '',
                        policyNumber: '',
                    },
                    repairer: {},
                    amounts: {},
                },
                allItems: [],
                selected: '',
                filesTableFields: [
                    {
                        label: 'File Name',
                        key: 'file_name',
                        sortable: true,
                        tdClass: 'file-name'
                    },
                    {
                        label: 'Date',
                        key: 'created_on',
                        sortable: true,
                        tdClass: 'uploaded-date'
                    },
                ],
                assessment: {
                    id: 0,
                    number: '',
                    policyNumber: '',
                    assessor_id: null,
                    assessment_date: null,
                    manual: {},
                    dateSettled: '',
                    rrAdjRate: '',
                    repairAdjRate: '',
                    paintAdjRate: '',
                    isClaimVirtual: false,
                },
                assessmentTab: {
                    assessment: {
                        number: "",
                        PAV: "",
                        actingOnBehalf: "",
                        quoteNumber: "",
                        quoteDate: "",
                        sumInsured: "",
                        insuredThirdParty: "",
                        inspectedAt: "",
                        claimInstruction: "",
                        policyNumber: "",
                        assessorId: "",
                        assessorName: "",
                        assessmentDate: "",
                    },
                    info: {
                        quoteNumber: "",
                    },
                    vehicle: {},
                },
                otherParty: {
                    details: {},
                    vehicle: {},
                },
                insured: {},
              vehicleOwnerNames: [],
                hasInvoice: false,
                invoice: {
                    id: 0,
                    number: '',
                },
                imageList: [],
                filesList: [],
                // Pin Image and Gallery
                pinImage: false,
                galleryCurrentIndex: 0,
                showGallery: false,
                assessorsList: [],
                selectedAssessor: null,
                activeTab: '',
                lastSelectedEstimateId: null,
                viewerIsAssessor: true,
                notes: [],
                notesSearch: null,
                addNoteTrigger: 0,
                customersList: [],
                estimators: [],
                legalFirms:[],
                innerRepairer: null,
                editableAccidentDatails: false,
            };
        },
        computed: {
            ...mapGetters({
                originalCompanyInfo: "currentCompany/getDetails",
                getterCurrentCompanyId: "currentCompany/getCompanyId",
                isUserRoleAssessor: 'currentUser/isRoleAssessor',
                isUserRoleLawyer: 'currentUser/isRoleLawyer',
                isNeedUpdateImages: "updater/isNeedUpdateImages",
                isNeedUpdateFiles: "updater/isNeedUpdateFiles",
                isAssessmentsCompany: "currentCompany/isAssessments",
            }),
            isEditableAccidentDetails() {
                return !!(this.editableAccidentDatails);
            },
            isEditable() {
                return !!this.isClaimVirtual && !this.isUserRoleLawyer;
            },
            isClaimVirtual() {
                return !!this.assessment.isClaimVirtual;
            },
            isPossibilityCreateInvoice() {
                if (Number(this.assessment.assessorId) > 0) {
                    let assessor = _.find(this.assessorsList, (i) => {
                        return Number(i.id) === Number(this.assessment.assessorId);
                    });
                    console.log('assessor', assessor);
                    if (assessor) {
                        let cid = assessor.cid;
                        if (Number(this.getterCurrentCompanyId) == cid) {
                            return true;
                        }
                    }

                }
                return false;
            },

            isOtherPartyAssessmentType() {
                return !!(this.assessment && this.assessment.type && this.assessment.type === "other_party");
            },
            isInsuredAssessmentType() {
                return !!(this.assessment && this.assessment.type && this.assessment.type === "insured");
            },
            isAssessmentNew() {
                return this.assessment.status && this.assessment.status == 'New';
            },
            isShowMarkAsProcessed() {
                return this.assessment.status && ['WRecoveries', 'OnHold', 'Completed', 'New'].includes(this.assessment.status);
            },
            isShowMarkAsWRecoveries() {
                return this.assessment.status && ['OnHold', 'New', 'Processing'].includes(this.assessment.status);
            },
            isShowMarkAsOnHold() {
                return this.assessment.status && ['WRecoveries', 'Processing', 'Completed'].includes(this.assessment.status);
            },
            isShowMarkAsNew() {
                return this.assessment.status && ['WRecoveries', 'Processing'].includes(this.assessment.status);
            },
            isShowMarkAsCompleted() {
                return this.assessment.status && ['WRecoveries', 'Processing', 'OnHold'].includes(this.assessment.status);
            },
            pageTitle() {
                let title = 'Assessment ';
                title += (!_.isEmpty(this.assessment.number)) ? this.assessment.number : ' ';
                title += ' | ';
                title += this.ownerName;
                title += ' | ';
                title += this.policyNumber;
                return title;
            },
            additionalPrices() {
                let obj = {
                    excess: 0,
                    contribution: 0,
                };
                if (this.assessment && this.assessment.type && this.assessment.type === 'other_party') {
                    obj = {
                        excess: (this.otherParty && this.otherParty.insurer && this.otherParty.insurer.excess && this.otherParty.insurer.excess > 0) ? this.otherParty.insurer.excess : 0,
                        contribution: (this.otherParty && this.otherParty.insurer && this.otherParty.insurer.contribution && this.otherParty.insurer.contribution > 0) ? this.otherParty.insurer.contribution : 0,
                    };
                } else {
                    obj = {
                        excess: (this.insured && this.insured.insurer && this.insured.insurer.excess && this.insured.insurer.excess > 0) ? this.insured.insurer.excess : 0,
                        contribution: (this.insured && this.insured.insurer && this.insured.insurer.contribution && this.insured.insurer.contribution > 0) ? this.insured.insurer.contribution : 0,
                    };
                }
                return obj;
            },
            policyNumber() {
                return (this.assessmentTab && this.assessmentTab.assessment && this.assessmentTab.assessment.policyNumber) ? this.assessmentTab.assessment.policyNumber : '';
            },
            ownerName() {
                if (this.assessment && this.assessment.type && this.assessment.type === 'other_party') {
                    return (this.otherParty && this.otherParty.details && this.otherParty.details.vehicleOwner) ? this.otherParty.details.vehicleOwner : '';
                } else {
                    return (this.insured && this.insured.insured && this.insured.insured.vehicleOwner) ? this.insured.insured.vehicleOwner : '';
                }
            },
            isSupItemListTabSelected() {
                return this.activeTab == 'Sup-Items List';
            },
            selectedSupItemListId() {
                return this.lastSelectedEstimateId;
            }
        },
        methods: {
            changeImageCategory(item) {
                if (!this.autoSaveUpdate.images) {
                    this.autoSaveUpdate.images = [];
                }
                this.autoSaveUpdate.images.push({id: item.id, newImageCategory: item.imageCategory});
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            changeFile(file) {
                if (!this.autoSaveUpdate.files) {
                    this.autoSaveUpdate.files = [];
                }
                this.autoSaveUpdate.files.push(file);
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            initMenu() {
                this.$root.$on('bv::dropdown::show', bvEvent => {
                    if (bvEvent.componentId === 'dropdown-2') {
                        this.isDropdown2Visible = true;
                    }
                });
                this.$root.$on('bv::dropdown::hide', bvEvent => {
                    if (bvEvent.componentId === 'dropdown-2') {
                        this.isDropdown2Visible = false;
                        // if(!_.isEmpty(this.$refs.optionMenu)) this.$refs.optionMenu.hide();
                    }
                    if (this.isDropdown2Visible) {
                        bvEvent.preventDefault();
                    }
                });
            },
            approveItems(all = false) {

                if (!this.matchingItemsResults) {
                    this.$toast.error('No matching results!');
                    return;
                }

                this.$bvModal.hide('checkTimesModal');

                NProgress.start();
                Axios.post(`/ir/assessment/${this.assessment.id}/approve-items`, {acceptAll: all, items: this.matchingItemsResults})
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.$toast.success('Items approved!');
                            this.loadAssessment(this.assessment.id);
                        } else {
                            this.$toast.error('Something went wrong');
                        }
                    })
                    .catch(e => {
                        console.error(e);
                        this.$toast.error('Something went wrong');
                    })
                    .finally(() => {
                        this.checkResults = null;
                        this.matchingItemsResults = null;
                        NProgress.done();
                    });
            },
            checkTimes(type) {
                this.checkResults = null;
                this.matchingItemsResults = null;
                this.$bvModal.show('checkTimesModal');
                Axios.post(`/ir/assessment/${this.assessment.id}/check-times/${type}`)
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.checkResults = response.data.results;
                            this.matchingItemsResults = response.data.itemsResults;
                            this.matchingItemsType = response.data.timesSchedule;
                            if (!response.data._curl._status || !response.data._curl._body._status) {
                                this.matchingItemsResults = null;
                                this.$toast.error('Got an error: ' + response.data._curl._body._error);
                            }
                        } else {
                            this.$toast.error('Something went wrong');
                        }
                    })
                    .catch(e => console.error(e));
            },
            newLegalFirm(newLegalFirm) {
                this.autoSaveUpdate.legalFirm = newLegalFirm;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            sendRepairerNotice() {
                this.$router.push(`/assessments/${this.assessmentId}/send-notice-to-repairer`);
            },
            deleteImage(q, item) {
                if (!confirm(`Confirm you want to DELETE this photo`)) {
                    return;
                }
                Axios.post(`/ir/assessment/${this.$route.params.assessmentId}/remove-file`, {fileId: item.id})
                    .then(response => {
                        if (response.data && response.data._status) {
                            let index = _.findIndex(this.imageList, el => Number(el.id) === Number(item.id));
                            console.log(index, item);
                            this.imageList.splice(index, 1);

                            this.$toast.success('Image removed!');
                            // this.$emit('fileUploaded');
                        } else {
                            this.$toast.error('Unable to remove image');
                        }
                    })
                    .catch(e => {
                        this.$toast.error('Unable to remove image');
                        console.error(e);
                    });
            },
            getCountItemsList: function (estimate) {
                let itemList = estimate.itemList;
                let val = 0;
                if (itemList && itemList.RR) {
                    val += itemList.RR.length;
                }
                if (itemList && itemList.Repair) {
                    val += itemList.Repair.length;
                }
                if (itemList && itemList.Paint) {
                    val += itemList.Paint.length;
                }
                if (itemList && itemList.Part) {
                    val += itemList.Part.length;
                }
                if (itemList && itemList.Materials) {
                    val += itemList.Materials.length;
                }
                if (itemList && itemList.Sublet) {
                    val += itemList.Sublet.length;
                }
                if (itemList && itemList.Other) {
                    val += itemList.Other.length;
                }
                if (itemList && itemList.PDR) {
                    val += itemList.PDR.length;
                }
                return val;
            },
            addSupplement() {
                this.$router.push('/assessments/' + this.assessmentId + '/add-supplement');
            },
            deleteAssessment() {
                let url = '/ir/assessment/' + this.assessment.id + '/delete';
                Axios.post(url)
                    .then(res => {
                        this.$refs.deleteAssessmentModal.hide();
                        if (res.data && res.data._status) {
                            this.$store.dispatch("assessment/deleteAssessmentById", this.assessment.id);
                            this.$toast.success("This Assessment has been deleted");
                            this.$router.push('/assessments');
                            return;
                        }
                        this.$toast.error("Something wrong. This Assessment isn't deleted");
                    })
                    .catch(e => console.warn(e))
                    .finally(() => {
                    });

            },
            clickOnForDelete() {
                let url = '/ir/assessment/' + this.assessment.id + '/for-delete';
                Axios.get(url)
                    .then(res => {
                        if (res.data && res.data._status) {
                            this.dataDeleteAssessment = res.data;
                            this.$refs.deleteAssessmentModal.show();
                            return;
                        }
                        this.$toast.error('Some error with get assessment data');
                    })
                    .catch(e => console.warn(e))
                    .finally(() => {
                    });
            },
            exportToXero() {
                Axios.post(`/ir/assessment/${this.assessment.id}/send-to-xero`)
                    .then(response => {
                        if (response.data && response.data._status) {
                            this.$toast.success('Sent to Xero! Invoice number is ' + response.data.invoiceNumber);
                            this.loadAssessment(this.assessmentId);
                        }
                    })
                    .catch(e => console.log(e));
            },
            updateOnXero() {
                Axios.post(`/ir/assessment/${this.assessment.id}/send-to-xero`)
                    .then(response => {
                        if (response.data && response.data._status) {
                            this.$toast.success('Invoice ' + response.data.invoiceNumber + ' has been updated on Xero');
                        }
                    })
                    .catch(e => console.log(e));
            },
            viewOnXero() {
                Axios.get(`/ir/assessment/${this.assessment.id}/get-xero-url`)
                    .then(response => {
                        if (response.data && response.data._status) {
                            window.open(response.data.url, '__blank');
                        }
                    })
                    .catch(e => console.log(e));
            },
            createInvoice() {
                NProgress.start();
                let url = '/ir/assessment/' + this.assessmentId + '/create-invoice';
                Axios.post(url, {assessmentId: this.assessmentId})
                    .then(response => {
                        if (response.data && response.data._status) {
                            this.$toast.success('Invoice has been created');
                            this.hasInvoice = true;
                        } else {
                            this.$toast.error('Invoice hasn\'t been created');
                        }

                    })
                    .catch((e) => {
                        this.$toast.error('Invoice hasn\'t been created');
                        console.error(e);
                    })
                    .finally(() => {
                        NProgress.done();
                    });
            },
            goToInvoice() {
                this.$router.push('/invoice/' + this.invoice.id);
            },
            fileUploaded() { // need remove this function. code moved to loadImages or loadFiles
                // this.loadAssessment(this.$route.params.assessmentId);
            },
            updateDataInRepairShop() {
                NProgress.start();
                let url = '/ir/assessment/' + this.assessmentId + '/update-repair-shop';
                Axios.post(url, {assessmentId: this.assessmentId})
                    .then(response => {
                        if (response.data && response.data._status && response.data.response && response.data.response._status) {
                            this.$toast.success('Update to estimate ' + response.data.response.estimate.number + ', successful');
                        } else if (response.data && response.data._status && response.data.response && response.data.estimate && response.data.response.estimate.number) {
                            this.$toast.error('Unable to update estimate ' + response.data.response.estimate.number);
                        } else {
                            this.$toast.error('Update to estimate not successful');
                            console.warn(response.data);
                        }
                    })
                    .catch((e) => {
                        this.$toast.error('Update to estimate not successful');
                        console.error(e);
                    })
                    .finally(() => {
                        NProgress.done();
                    });
            },
            addManualItem(part){

            },
            moveItemPart(part) {
                if (!this.autoSaveUpdate.moveItems) {
                    this.autoSaveUpdate.moveItems = {};
                }
                let key = part.type + part.id;
                if (!this.autoSaveUpdate.moveItems[key]) {
                    this.autoSaveUpdate.moveItems[key] = {};
                }
                this.autoSaveUpdate.moveItems[key] = part;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            autoSaveItemPart(part) {
                //console.log('part', part);
                if (!this.autoSaveUpdate.items) {
                    this.autoSaveUpdate.items = {};
                }
                let key = part.type + part.id;
                if (!this.autoSaveUpdate.items[key]) {
                    this.autoSaveUpdate.items[key] = {};
                }
                this.autoSaveUpdate.items[key] = part;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            onAssessmentLegalFirmChanged(val) {
                if (!this.autoSaveUpdate.details) {
                    this.autoSaveUpdate.details = {};
                }
                if (val && val.id > 0) {
                    this.assessment.legalFirmId = val.id;
                    this.autoSaveUpdate.details.legalFirmId = this.assessment.legalFirmId;
                } else {
                    this.autoSaveUpdate.details.legalFirm = val.name;
                }
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            onSelectAssessor(sel) {
                if (!this.autoSaveUpdate.details) {
                    this.autoSaveUpdate.details = {};
                }
                this.autoSaveUpdate.details.assessorId = sel;
                this.beforeDebouncedUnsavedChanges();
                this.beforeDebouncedAutoSave();
            },
            downloadAuthorityPdf: function () {
                let assessment_id = this.$route.params.assessmentId;
                let token = localStorage.getItem('token');
                window.open(appConfig.baseAPIURL + `/ir/assessment/download-authority-pdf/${assessment_id}&at=${token}`);
            },
            downloadAssessmentReportPdf: function () {
                let assessment_id = this.$route.params.assessmentId;
                let token = localStorage.getItem('token');
                window.open(appConfig.baseAPIURL + `/ir/assessment/download-report-pdf/${assessment_id}&at=${token}`);
            },
            markAssessmentAsProcessing() {
                Axios.post(`/ir/assessment/${this.$route.params.assessmentId}/mark-as-processing`)
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.$toast.success('Success');
                            this.loadAssessment(this.$route.params.assessmentId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            markAssessmentAsWRecoveries() {
                Axios.post(`/ir/assessment/${this.$route.params.assessmentId}/mark-as-wrecoveries`)
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.$toast.success('Success');
                            this.loadAssessment(this.$route.params.assessmentId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            markAssessmentAsOnHold() {
                Axios.post(`/ir/assessment/${this.$route.params.assessmentId}/mark-as-on-hold`)
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.$toast.success('Success');
                            this.loadAssessment(this.$route.params.assessmentId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            markAssessmentAsNew() {
                Axios.post(`/ir/assessment/${this.$route.params.assessmentId}/mark-as-new`)
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.$toast.success('Success');
                            this.loadAssessment(this.$route.params.assessmentId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            markAssessmentAsCompleted() {
                Axios.post(`/ir/assessment/${this.$route.params.assessmentId}/mark-as-completed`)
                    .then(response => {
                        if (response && response.data && response.data._status) {
                            this.$toast.success('Success');
                            this.loadAssessment(this.$route.params.assessmentId);
                        }
                    })
                    .catch(e => console.error(e));
            },
            changePositionByArrowKey: function (ref, event) {
                let el = this.$refs[ref];
                if (el) {
                    el.focus();
                }
            },
            changedTab: function (obj) {
                console.log(obj);
                if (obj.tab.$attrs['data-estimate-id']) {
                    this.lastSelectedEstimateId = obj.tab.$attrs['data-estimate-id'];
                }
                this.activeTab = obj.tab.name;
            },
            clickSave: function () {

            },
            autoSave() {
                this.autoSaveMessage = 'Saving...';
                let updateData = Object.assign({}, this.autoSaveUpdate);
                this.autoSaveUpdate = {};
                return Axios({
                    method: 'post',
                    responseType: 'json',
                    headers: {'Autosave': true},
                    url: `/ir/assessment/${this.$route.params.assessmentId}`,
                    validateStatus: function (status) {
                        return status < 500;
                    },
                    data: updateData
                })
                    .then(response => {
                        if (response && response.status === 200 && response.data && response.data._status) {
                            this.autoSaveMessage = 'Saved';
                            if (response.data.isAssessmentInfoUpdate
                                || response.data.isVehicleUpdate
                                || response.data.isRepairerUpdate) {
                                //this.isAutoSave = false;
                                //this.loadAssessment(this.$route.params.assessmentId);
                            }
                            if (response.data.isItemsUpdate && response.data.isItemsUpdate._status) {
                                //  this.isAutoSave = false;
                                this.updateItems(response.data.isItemsUpdate.items);
                                // this.isAutoSave = true;
                            }
                            if (response.data.isNewLegalFirm && response.data.isNewLegalFirm._status) {
                                this.legalFirms.push({id: response.data.isNewLegalFirm.legalFirmId, name: response.data.isNewLegalFirm.legalFirmName});
                                this.assessment.legalFirmId = response.data.isNewLegalFirm.legalFirmId;
                            }
                            if (response.data.isMoveItemsUpdate && response.data.isMoveItemsUpdate._status) {
                                this.isAutoSave = false;
                                this.allItems = response.data.isMoveItemsUpdate.items;
                                console.log('test', this.allItems);
                                this.isAutoSave = true;
                            }

                        } else {
                            this.autoSaveMessage = 'Unsaved Changes';
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.autoSaveMessage = 'Unsaved Changes';
                    });
            },
            showUnsavedChanges: function () {
                if (!this.isAutoSave) {
                    return;
                }
                this.autoSaveMessage = 'Unsaved Changes';
            },
            hideSavedChanges() {
                if (!this.isAutoSave) {
                    return;
                }
                this.autoSaveMessage = '';
            },
            beforeDebouncedAutoSave: function () {
                if (!this.isAutoSave) {
                    return;
                }
                this.debouncedAutoSave();
            },
            beforeDebouncedUnsavedChanges: function () {
                if (!this.isAutoSave) {
                    return;
                }
                this.debouncedUnsavedChanges();
            },
            //setAssessmentInfo(data) {
            //
            //    if (!this.info) {
            //        this.info = {};
            //        if (!this.info.vehicle) {
            //            this.info.vehicle = {};
            //        }
            //    }
            //    if (!this.info.vehicle.rego || this.info.vehicle.rego == '')
            //    {
            //        this.info.vehicle.rego =
            //    }
            //},
            updateItems(items) {
                let allItems = this.allItems;
                let vm = this;
                _.forEach(items, function (updateItem, key) {
                    _.forEach(allItems, function (estimate) {
                        if (estimate && estimate.info && estimate.info.id && Number(estimate.info.id) == Number(key)) {
                            vm.$set(estimate.itemsList, 'Materials', updateItem);
                            //_.forEach(estimate.itemsList.Materials, function (item) {
                            //    if (updateItem.id == item.id) {
                            //        item.name = updateItem.name;
                            //        item.adj_hours = updateItem.adj_hours;
                            //        item.adj_price = updateItem.adj_price;
                            //        console.log(updateItem);
                            //    }
                            //});
                        }
                    });
                });
            },
            loadImages() {
                console.log('start load images');
                let id = this.$route.params.assessmentId;
                this.loadAssessment(id, data => {
                    this.imageList = data.images;
                    this.$store.dispatch('updater/resetImages');
                });
            },
            loadFiles() {
                console.log('start load files');
                let id = this.$route.params.assessmentId;
                this.loadAssessment(id, data => {
                    this.filesList = data.files;
                    this.$store.dispatch('updater/resetFiles');
                });
            },
            loadAssessment: function (id, callbackToReturn = false) {
                NProgress.start();
                let vm = this;
                this.assessmentId = id;
                Axios.get('/ir/assessment/' + id)
                    .then((response) => {
                        if (response.data && response.data._status) {
                            if (callbackToReturn) {
                                callbackToReturn(response.data);
                                return;
                            }
                            this.claim = response.data.claim;
                            this.hasInvoice = response.data.hasInvoice;
                            if (response.data.invoice) {
                                this.invoice = response.data.invoice;
                            }
                            if (response.data.legalFirms) {
                                this.legalFirms = response.data.legalFirms;
                            }
                            this.assessment = response.data.assessment;
                            this.assessmentTab = response.data.assessmentTab;
                            this.otherParty = response.data.otherParty;
                            this.allItems = response.data.allItems;
                            this.estimators = response.data.estimators;
                            if (response.data.vehicleOwnerNames){
                              this.vehicleOwnerNames=response.data.vehicleOwnerNames;
                            }
                            _.forEach(this.allItems, function (estimate) {
                                //   console.log('111:');
                                if (estimate && estimate.info) {
                                    //     console.log('222:');
                                    vm.$set(estimate.info, 'quotedSubtotal', 0);
                                    vm.$set(estimate.info, 'assessedSubtotal', 0);
                                    vm.$set(estimate.info, 'isSomeItemsAssessed', false);
                                }
                            });

                            this.insured = response.data.insured;
                            this.imageList = response.data.images;
                            this.filesList = response.data.files;
                            this.info = response.data.info;
                            this.viewerIsAssessor = response.data.viewerIsAssessor;
                            this.innerRepairer = response.data.innerRepairer;
                            this.editableAccidentDatails = response.data.editableAccidentDatails;
                            this.vehicleOwnerList = response.data.vehicleOwnerList;

                            this.loadNotes();
                            this.$nextTick(() => {
                                if (this.$route.hash) {
                                    let hash = this.$route.hash;
                                    this.$refs['assessment-view-tabs'].selectTab(hash);
                                    window.history.replaceState({}, '', window.location.href.split('#')[0]);
                                }
                            });

                            Axios.get('/ir/assessment/assessors')
                                .then((response) => {
                                    if (response.data) {
                                        this.assessorsList = response.data;
                                        let found = false;
                                        this.assessorsList.forEach(a => {
                                            if (a.id == this.assessment.assessorId) {
                                                found = true;
                                            }
                                        });
                                        this.assessment.assessorFoundInList = found;
                                    }
                                })
                                .catch((error) => {
                                    console.log('error:', error);
                                });

                            setTimeout(function () {
                                vm.isAutoSave = true;
                            }, 500);
                        }
                    })
                    .catch((error) => {
                        console.log('error:', error);
                    })
                    .finally(() => NProgress.done());

            },
            handleCloseGallery() {
                this.showGallery = false;
            },
            handleSelectPinImage(index) {
                this.galleryCurrentIndex = index;
                this.showGallery = true;
            },

            loadNotes() {
                Axios.get('/ir/assessment/' + this.assessment.id + '/notes')
                    .then(res => {
                        if (res.data && res.data._status) {
                            if (res.data.data) {
                                this.notes = res.data.data;
                            }
                        }
                    })
                    .catch(e => console.warn(e));
            },
            addNote() {
                this.addNoteTrigger++;
            },
            clickGoToActivityTab() {
                let hash = this.$refs['activity-tab'].hash;
                this.$refs['assessment-view-tabs'].selectTab(hash);
            },
            createTask() {
                this.clickGoToActivityTab();
                this.$refs['assessment-view-activity-tab'].showNewTaskForm();
            }
        },
        created: function () {
            this.debouncedAutoSave = _.debounce(this.autoSave, 1000);
            this.debouncedSavedChanges = _.debounce(this.hideSavedChanges, 10000);
            this.debouncedUnsavedChanges = _.debounce(this.showUnsavedChanges, 50);
        },
        mounted: function () {
            let params = this.$route.params;
            this.initMenu();
            this.assessmentId = params.assessmentId;
            this.loadAssessment(this.assessmentId);
            this.$nextTick(() => {
                if (params && params.action && params.action == 'goToTask') {
                    this.clickGoToActivityTab();
                }
            });
        },
        watch: {
            isNeedUpdateFiles(newVal) {
                console.log('loadFiles - ', newVal);
                if (newVal === true) {
                    this.loadFiles();
                }
            },
            isNeedUpdateImages(newVal) {
                console.log('loadImages - ', newVal);
                if (newVal === true) {
                    this.loadImages();
                }
            },
            'assessment': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.autoSaveUpdate.details) {
                        this.autoSaveUpdate.details = {};
                    }
                    this.autoSaveUpdate.details = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'assessment.rrAdjRate': {
                handler(newVal) {
                    if (!this.autoSaveUpdate.itemsRates) {
                        this.autoSaveUpdate.itemsRates = {};
                    }
                    this.autoSaveUpdate.itemsRates.rrAdjRate = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'assessment.repairAdjRate': {
                handler(newVal) {
                    if (!this.autoSaveUpdate.itemsRates) {
                        this.autoSaveUpdate.itemsRates = {};
                    }
                    this.autoSaveUpdate.itemsRates.repairAdjRate = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'assessment.paintAdjRate': {
                handler(newVal) {
                    if (!this.autoSaveUpdate.itemsRates) {
                        this.autoSaveUpdate.itemsRates = {};
                    }
                    this.autoSaveUpdate.itemsRates.paintAdjRate = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'assessmentTab.assessment': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.assessmentInfo) {
                        this.autoSaveUpdate.assessmentInfo = {};
                    }
                    this.autoSaveUpdate.assessmentInfo.assessment = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'assessmentTab.info': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.assessmentInfo) {
                        this.autoSaveUpdate.assessmentInfo = {};
                    }
                    this.autoSaveUpdate.assessmentInfo.info = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'assessmentTab.vehicle': {
                deep: true,
                handler(newVal, oldVal) {
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.assessmentInfo) {
                        this.autoSaveUpdate.assessmentInfo = {};
                    }
                    this.autoSaveUpdate.assessmentInfo.vehicle = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'otherParty.accident.details': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('op.a.d');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.otherParty) {
                        this.autoSaveUpdate.otherParty = {};
                    }
                    if (!this.autoSaveUpdate.otherParty.accident) {
                        this.autoSaveUpdate.otherParty.accident = {};
                    }
                    if (!this.autoSaveUpdate.otherParty.accident.details) {
                        this.autoSaveUpdate.otherParty.accident.details = {};
                    }
                    this.autoSaveUpdate.otherParty.accident.details = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.accident.details': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('insured.a.d');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    if (!this.autoSaveUpdate.insured.accident) {
                        this.autoSaveUpdate.insured.accident = {};
                    }
                    if (!this.autoSaveUpdate.insured.accident.details) {
                        this.autoSaveUpdate.insured.accident.details = {};
                    }
                    this.autoSaveUpdate.insured.accident.details = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'otherParty.details': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.otherParty.details');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.otherParty) {
                        this.autoSaveUpdate.otherParty = {};
                    }
                    this.autoSaveUpdate.otherParty.details = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
          'otherParty.details.vehicleOwner': {
            handler(newVal, oldVal) {
              console.log('watch.otherParty.details.vehicleOwner', newVal);
              if (!this.isAutoSave) {
                return;
              }
              if (!this.isEditable && !this.isAssessmentsCompany) {
                return;
              }
              this.autoSaveUpdate.changeVehicleOwner = newVal;
              this.beforeDebouncedUnsavedChanges();
              this.beforeDebouncedAutoSave();
            }
          },
            'otherParty.vehicle': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.otherParty.vehicle');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.otherParty) {
                        this.autoSaveUpdate.otherParty = {};
                    }
                    this.autoSaveUpdate.otherParty.vehicle = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                    this.assessmentTab.vehicle.badge = newVal.badge;
                    this.assessmentTab.vehicle.body = newVal.body;
                    this.assessmentTab.vehicle.colour = newVal.colour;
                    this.assessmentTab.vehicle.colourVariant = newVal.colourVariant;
                    this.assessmentTab.vehicle.dom = newVal.dom;
                    this.assessmentTab.vehicle.make = newVal.make;
                    this.assessmentTab.vehicle.model = newVal.model;
                    this.assessmentTab.vehicle.odometer = newVal.odometer;
                    this.assessmentTab.vehicle.rego = newVal.rego;
                    this.assessmentTab.vehicle.series = newVal.series;
                    this.assessmentTab.vehicle.transmission = newVal.transmission;
                    this.assessmentTab.vehicle.vin = newVal.vin;
                }
            },
            'otherParty.insurer': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.otherParty.insurer');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.otherParty) {
                        this.autoSaveUpdate.otherParty = {};
                    }
                    this.autoSaveUpdate.otherParty.insurer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'otherParty.innerRepairer': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.otherParty.innerRepairer');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.otherParty) {
                        this.autoSaveUpdate.otherParty = {};
                    }
                    this.autoSaveUpdate.otherParty.innerRepairer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.insured': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.insured.insured');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.insured = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
          'insured.insured.vehicleOwner': {
            handler(newVal, oldVal) {
              console.log('watch.insured.insured.vehicleOwner:', newVal);
              if (!this.isAutoSave) {
                return;
              }
              if (!this.isEditable && !this.isAssessmentsCompany) {
                return;
              }
              this.autoSaveUpdate.changeVehicleOwner = newVal;
              this.beforeDebouncedUnsavedChanges();
              this.beforeDebouncedAutoSave();
            }
          },
            'insured.vehicle': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.insured.vehicle');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.vehicle = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                    this.assessmentTab.vehicle.badge = newVal.badge;
                    this.assessmentTab.vehicle.body = newVal.body;
                    this.assessmentTab.vehicle.colour = newVal.colour;
                    this.assessmentTab.vehicle.colourVariant = newVal.colourVariant;
                    this.assessmentTab.vehicle.dom = newVal.dom;
                    this.assessmentTab.vehicle.make = newVal.make;
                    this.assessmentTab.vehicle.model = newVal.model;
                    this.assessmentTab.vehicle.odometer = newVal.odometer;
                    this.assessmentTab.vehicle.rego = newVal.rego;
                    this.assessmentTab.vehicle.series = newVal.series;
                    this.assessmentTab.vehicle.transmission = newVal.transmission;
                    this.assessmentTab.vehicle.vin = newVal.vin;
                }
            },
            'insured.insurer': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.insured.insurer');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.insurer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.innerRepairer': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('watch.insured.innerRepairer');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.isEditable) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    this.autoSaveUpdate.insured.innerRepairer = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'otherParty.accident.details': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('op.a.d');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.otherParty) {
                        this.autoSaveUpdate.otherParty = {};
                    }
                    if (!this.autoSaveUpdate.otherParty.accident) {
                        this.autoSaveUpdate.otherParty.accident = {};
                    }
                    if (!this.autoSaveUpdate.otherParty.accident.details) {
                        this.autoSaveUpdate.otherParty.accident.details = {};
                    }
                    this.autoSaveUpdate.otherParty.accident.details = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
            'insured.accident.details': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('insured.a.d');
                    if (!this.isAutoSave) {
                        return;
                    }
                    if (!this.autoSaveUpdate.insured) {
                        this.autoSaveUpdate.insured = {};
                    }
                    if (!this.autoSaveUpdate.insured.accident) {
                        this.autoSaveUpdate.insured.accident = {};
                    }
                    if (!this.autoSaveUpdate.insured.accident.details) {
                        this.autoSaveUpdate.insured.accident.details = {};
                    }
                    this.autoSaveUpdate.insured.accident.details = newVal;
                    this.beforeDebouncedUnsavedChanges();
                    this.beforeDebouncedAutoSave();
                }
            },
        },
        components: {
            AssessmentViewInsuredTab,
            ItemsListTab,
            imagePinArea,
            imageGallery,
            FileUpload,
            AssessmentTab,
            AssessmentViewOtherPartyTab,
            NumberFormatter,
            FilesTab,
            ImagesTab,
            Notes,
            ActivityTab,
        }
    };
</script>
<style lang="scss" scoped>
    #repairer-supplier-view-options {
        min-width: 165px;
    }

    #repairer-supplier-view-options ::v-deep .dropdown-menu {
        min-width: 165px;
    }
</style>
<style lang="scss">
    .part-list-quote-pricing-progress {
        min-width: 450px;
        padding-left: 0px !important;
    }

    .part-list-quote-pricing-progress .quote-pricing-progress .wizard__divider {
        display: none !important;
    }

    .multiselect--disabled {
        opacity: 1 !important;
    }

    .assessment-view-page {
        .dropdown-menu {
            &__save-button {
                display: block;
                width: 80% !important;
                color: white !important;
                text-align: center;
                margin: 15px auto;
            }

            .theme-repairer &__save-button {
                background-color: var(--repairer-color) !important;
            }
        }
    }

    .assessment-view-page .part-list .assessment-received .table {
        width: 568px;
    }

    .assessment-view-page .vehicle-details-block {
        width: 572px;
        margin-left: 15px;
        margin-top: 15px;
    }

    .assessment-view-page .best-value {
        max-width: 217px;
        width: auto;
    }

    @media (min-width: 992px) {
        .best-value {
            width: 270px !important;
        }
        @media (min-width: 992px) {
            .part-list .table-width {
                // width: 866px;
            }
        }
    }

    @media screen and (max-width: 425px) {
        .V3 .assessment-view-page .vehicle-details-block {
            width: 97%;
            padding-right: 15px;
        }
        .assessment-view-page .part-list {
            margin-top: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
        }
        .tab__button-group {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            padding: 10px 10px 0px;

            .tab__button {
                margin: 0px 0px 10px 0px !important;
                height: 80px;
                flex: 50%;
            }
        }
        .assessment-view-page .part-list .assessment-received .table {
            width: 100%;
        }
    }

    .V3 .assessment-view-page .part-list-supplier {
        box-sizing: border-box;
    }

    /* price click effect */
    /*.V3 .assessment-view-page .part-list .part-list-supplier:active,*/
    /*.V3 .assessment-view-page .part-list-priced .part-list-supplier:focus {*/
    /*    background-color: rgba(46, 169, 255, 0.2);*/
    /*}*/
    .V3 .assessment-view-page .part-list .part-list-supplier:active {
        background-color: rgba(46, 169, 255, 0.2);
    }

    /* price hover effect */
    .V3 .assessment-view-page .part-list .part-list-supplier[role='cell']:hover {
        border: 2px solid rgba(46, 169, 255, 1);
        // background-color: rgba(46,169,255,0.083);
        cursor: pointer;
    }

    .V3 .assessment-view-page .offer-checked {
        border: 0px;
        background-color: rgba(46, 169, 255, 0.1);
    }

    .assessment-view-page .part-list {
        margin-top: 15px;
        margin-left: 15px;
    }

    .assessment-view-page .part-list .table {
        width: 866px;
    }

    .assessment-view-page .part-list th {
        padding-left: 15px;
        padding-right: 15px;
    }

    .assessment-view-page .part-list td {
        padding-left: 15px;
        padding-right: 15px;
    }

    .assessment-view-page .part-list th.part-list-part-name,
    .assessment-view-page .part-list td.part-list-part-name {
        width: 560px;
    }

    .assessment-view-page .part-list th.part-list-part-name,
    .assessment-view-page .part-list th.part-list-number,
    .assessment-view-page .part-list th.part-list-qty,
    .assessment-view-page .part-list th.part-list-rrp {
        padding-top: 26px;
    }

    .assessment-view-page .part-list th.part-list-part-name div,
    .assessment-view-page .part-list th.part-list-qty div.div-qty,
    .assessment-view-page .part-list th.part-list-rrp div.div-qty {
        float: left;
    }


    .assessment-view-page .part-list th.part-list-part-name span,
    .assessment-view-page .part-list th.part-list-qty span,
    .assessment-view-page .part-list th.part-list-rrp span,
    .assessment-view-page .part-list th.part-list-number span {
        background-image: url("data:image/svg+xml;base64,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");
        height: 16px;
        width: 8px;
        display: inline-block;
        cursor: pointer;
    }

    .assessment-view-page .part-list th.part-list-part-name span {
        margin-left: 5px;
    }

    .assessment-view-page .part-list th.part-list-qty span {
        margin-left: 5px;
    }

    .assessment-view-page .part-list th.part-list-rrp span {
        margin-left: 5px;
    }

    .V3 .assessment-view-page .part-list-qty,
    .V3 .assessment-view-page .part-list-rrp,
    .V3 .assessment-view-page .part-list[role='cell'] {
        min-width: 68px;
    }

    .assessment-view-page .part-list th.part-list-qty,
    .assessment-view-page .part-list td.part-list-qty,
    .assessment-view-page .part-list th.part-list-rrp,
    .assessment-view-page .part-list td.part-list-rrp {
        width: 70px;
    }

    .assessment-view-page .part-list th.part-list-number,
    .assessment-view-page .part-list td.part-list-number,
    .assessment-view-page .part-list th.part-list-supplier,
    .assessment-view-page .part-list td.part-list-supplier {
        width: 135px;
    }

    .assessment-view-page .part-list td div.part-list-item-name {
        color: #1C1F39;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 16px;
    }

    .assessment-view-page .part-list td div.part-list-item-number {
        color: #1C1F39;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
    }

    .assessment-view-page .part-list td div.part-list-item-qty,
    .assessment-view-page .part-list td div.part-list-item-rrp {
        color: #1C1F39;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
    }

    .assessment-view-page .part-list .part-list-item-price {
        opacity: 0.5;
        color: #1C1F39;
    }

    .assessment-view-page .part-list .part-list-item-price--priced {
        opacity: 1;
    }

    .assessment-view-page .part-list .supplier-icon {
        font-size: 20px;
        margin-bottom: 5px;
    }

    .assessment-view-page .part-list .supplier-icon img {
        max-height: 25px;
    }

    .assessment-view-page .part-list .supplier-icon .bx {
        opacity: 0.5;
    }

    .assessment-view-page .part-list .supplier-name {
        color: #1C1F39;
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
        height: 36px;
        margin-bottom: 10px;
    }

    .assessment-view-page .part-list .supplier-type {
        color: #1C1F39;
        font-size: 12px;
        font-style: italic;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
        text-align: center;
    }

    .assessment-view-page .part-list .table .subheader {
        opacity: 0.5;
        color: #1C1F39;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 25px;
        padding-right: 0px;
    }

    .assessment-view-page .part-list .table .subheader {
        line-height: 25px !important;
    }

    .assessment-view-page .part-list .table .subheader-p-c {
        text-align: left;
        padding-left: 150px; // 30px
        height: 42px;
        /*  border-right: 1px solid rgba(27, 30, 56, 0.1);*/

    }

    .assessment-view-page .part-list .table .subheader-t {
        text-align: left;
        padding-left: 150px;
        height: 57px;

        position: relative;
    }

    .assessment-view-page .part-list .table .p-c-value {
        color: #1C1F39;;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 16px;
    }

    .assessment-view-page .part-list .table .totals-value {
        color: #1C1F39;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 19px;
    }

    .assessment-view-page .part-list .subheader.parts-footer {
        opacity: 1;
        color: #1C1F39;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 25px;
        padding-left: 150px;
    }

    .assessment-view-page .part-list .subheader span.subheader-border-right {
        border-right: 1px solid rgba(27, 30, 56, 0.2);
        width: 1px;
        float: right;
        height: 25px;
        margin-left: 30px;
    }

    .assessment-view-page .part-list .btn.order {
        min-width: 78px;
    }

    .assessment-view-page .part-list .btn-outline-primary.order {
        color: #00B050;
    }

    /* global */
    .part-list .table {
        width: auto;
    }

    .tab {
        &__button-group {
            margin-bottom: 30px;
        }

        &__button {
            margin-top: 0;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0px;
            }
        }
    }

    #checkTimesModal .modal-content {
        border-radius: 0.3rem !important;
    }
</style>

<style scoped>

    div.box {
        text-align: center;
    }

    div.box img {
        /*display: block;*/
        height: 9rem;
    }

    .img-box {
        position: relative;
        width: 100%;
        height: 250px;
    }

    .img-box a {
        display: inline-block;
        height: 250px;
    }

    .img-box a img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .delivery-required-time {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    @media screen and (min-width: 1200px) {
        .delivery-required-time {
            margin-top: 45px;
        }
    }


</style>

<style>
    .assessment-view-page .white-text {
      color: white !important;
    }
    /* overwrite b-dropdown */
    .options-check-time.b-dropdown {
        width: 100%;
    }

    .options-check-time button.btn.btn-secondary {
        font-size: 12px;
        font-weight: 600;
        padding: 15px 5px 15px 15px;
        border: none;
    }

    .options-check-time button.btn.btn-secondary:before {
        content: unset;
    }

    .options-check-time button.btn.btn-secondary .bx {
        /*font-size: 18px;*/
        position: absolute;
        top: 15px;
        left: 3px;
    }

    .options-check-time button.btn.btn-secondary:active,
    .options-check-time button.btn.btn-secondary:focus,
    .options-check-time button.btn.btn-secondary:hover,
    .options-check-time button.btn.btn-secondary[aria-expanded="true"] {
        background-color: rgba(255, 127, 46, 0.1);
        color: #00B050;
    }

    /* end overwrite */

</style>
